<template>
    <div>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        <v-data-table :headers="headers" :items="companies" :search="search" :single-expand="false" :expanded.sync="expanded" item-key="company_id" show-expand>
            <template v-slot:item.verification_domain="{ item }">
                <!-- Verwenden Sie v-tooltip und benutzerdefinierte Stile -->
                <v-tooltip bottom style="max-width: 300px;">
                    <template v-slot:activator="{ on }">
                        <div v-on="on" class="truncate-text">{{ item.verification_domain }}</div>
                    </template>
                    <div class="truncate-tooltip">
                        {{ item.verification_domain }}
                    </div>
                </v-tooltip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <!-- <v-list-item @click="editCompany(item)">
                            <v-list-item-title>Edit</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item
                            @click="
                                selectedCompany = item
                                changePlanDialog = true
                            "
                        >
                            <v-list-item-title>change plan</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.cs_status == 'not allowed'" @click="grantCs(item)">
                            <v-list-item-title>allow content suite test</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.cs_status !== 'not allowed' && item.cs_status !== 'test_ended'" @click="switchCsStatus(item, 'test_ended')">
                            <v-list-item-title>end content suite test</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.cs_status == 'test_ended'" @click="switchCsStatus(item, 'testing')">
                            <v-list-item-title>allow content suite test again</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.status !== 'testing'" @click="switchActiveStatus(item, 'testing')">
                            <v-list-item-title>switch company status to: testing</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.status !== 'active'" @click="switchActiveStatus(item, 'active')">
                            <v-list-item-title>switch company status to: active</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.status !== 'test_ended'" @click="switchActiveStatus(item, 'test_ended')">
                            <v-list-item-title>switch company status to: test_ended</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.status !== 'inactive'" @click="switchActiveStatus(item, 'inactive')">
                            <v-list-item-title>switch company status to: inactive</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item v-if="item.status == 'inactive'" @click="deleteCompany(item)">
                            <v-list-item-title>delete company</v-list-item-title>
                        </v-list-item> -->
                    </v-list>
                </v-menu>
                <!-- Change Group Dialog -->
                <v-dialog v-model="changePlanDialog" max-width="400" height="300px">
                    <v-card>
                        <v-card-title>
                            {{ selectedCompany ? selectedCompany.name : "" }}
                        </v-card-title>
                        <v-card-subtitle>
                            Change Plan
                        </v-card-subtitle>

                        <v-card-text>
                            <v-select
                                color="primary"
                                v-model="newplan"
                                :items="plans"
                                filled
                                prepend-icon="mdi-account-group"
                                label="select new plan"
                                item-text="text"
                                item-value="value"
                                return-object
                            >
                            </v-select>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn rounded class="mx-auto" color="primary" dark @click="changePlan"> Change Plan </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <!-- <v-dialog
          v-model="item.text"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              fab
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                small
                color="primary"
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Edit Company </span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.name"
                      label="Dessert name"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.calories"
                      label="Calories"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.fat"
                      label="Fat (g)"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.carbs"
                      label="Carbs (g)"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model="editedItem.protein"
                      label="Protein (g)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="item.text = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="editItem(item)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    Requests Overall: {{ item.requestCount > 0 ? item.requestCount : 0 }}
                    <br />
                    Update requests overall: {{ item.requestsUpdates > 0 ? item.requestsUpdates : 0 }}
                    <br />
                    Requests in last 30 days: {{ item.requestsCounts30Days > 0 ? item.requestsCounts30Days : 0 }}
                    <br />
                    Update requests in last 30 days: {{ item.requestsUpdates30Days > 0 ? item.requestsUpdates30Days : 0 }}
                </td>
            </template>
        </v-data-table>
    </div>
</template>
<script>
    export default {
        data: () => ({
            /**********************************************************
             * Overview of Companies Datatable:
             **********************************************************/
            auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            editDialog: false,
            editedItem: {
                name: "",
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0
            },
            expanded: [],
            singleExpand: false,

            search: "",
            headers: [
                { text: "ID", filterable: true, sortable: true, value: "company_id" },
                { text: "Company", filterable: true, sortable: true, value: "name" },
                { text: "Domains", filterable: true, sortable: false, value: "verification_domain" },
                // { text: "Host", filterable: false, sortable: true, value: "mongo_host" },
                // { text: "Port", filterable: false, sortable: true, value: "mongo_port" },
                // { text: "User", filterable: false, sortable: true, value: "mongo_user" },
                { text: "Users", filterable: false, sortable: true, value: "userCount" },
                { text: "Status", filterable: false, sortable: true, value: "status" },
                { text: "Plan", filterable: false, sortable: true, value: "plan" },
                { text: "Content Suite", filterable: false, sortable: true, value: "content_suite" },
                { text: "Content Suite Status", filterable: false, sortable: true, value: "cs_status" },
                { text: "Actions", filterable: false, sortable: false, value: "actions" },
                { text: "", value: "data-table-expand" }
            ],
            companies: [],
            selectedCompany: {},

            //change plan dialog
            changePlanDialog: false,
            plans: [
                { value: 0, text: "0 - Research & Brand Dashboard" },
                { value: 1, text: "1 - Research" },
                { value: 3, text: "3 - Research Single" }
            ], //o = admin , 1 = user
            newplan: null
        }),
        methods: {
            switchCsStatus(item, status) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/company/cs/change/status", { company_id: item.company_id, new_status: status }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCompanies()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            grantCs(item) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/company/cs/add", { company_id: item.company_id }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCompanies()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            changePlan() {
                this.$http
                    .post(
                        process.env.VUE_APP_APIURL + "/admin/company/switch/plan",
                        { company_id: this.selectedCompany.company_id, new_plan: this.newplan.value },
                        { headers: { Authorization: this.auth } }
                    )
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCompanies()
                        this.changePlanDialog = false
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            switchActiveStatus(item, newstatus) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/company/switch/status", { company_id: item.company_id, newstatus: newstatus }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCompanies()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fetchCompanies: function() {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/company/mongoDatabases", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        // console.log(response.body);
                        this.fetchRequests(response.body)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fetchCsCompanies: function() {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/admin/company/cs", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.companies = this.companies.map((x) => {
                            let result = response.body.find((y) => y.company_id == x.company_id)
                            if (result) {
                                x.content_suite = 1
                                x.cs_status = result.status
                            } else {
                                x.content_suite = 0
                                x.cs_status = "not allowed"
                            }
                            return x
                        })
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            deleteCompany: function(item) {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/admin/company/delete/" + item.company_id, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.fetchCompanies()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fetchRequests(companies) {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/admin/monitoring/companyInformations", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response)

                        for (let companiesCounter = 0; companiesCounter < companies.length; companiesCounter++) {
                            for (let responseCounter = 0; responseCounter < response.body.requestCounts.length; responseCounter++) {
                                if (response.body.requestCounts[responseCounter].company_id == companies[companiesCounter].company_id) {
                                    companies[companiesCounter].requestCount = response.body.requestCounts[responseCounter].request_count
                                }
                            }
                            for (let response30DaysCounter = 0; response30DaysCounter < response.body.requestsCounts30Days.length; response30DaysCounter++) {
                                if (response.body.requestsCounts30Days[response30DaysCounter].company_id == companies[companiesCounter].company_id) {
                                    companies[companiesCounter].requestsCounts30Days = response.body.requestsCounts30Days[response30DaysCounter].request_count
                                }
                            }
                            for (let responseAutoUpdateCounter = 0; responseAutoUpdateCounter < response.body.requestsUpdates.length; responseAutoUpdateCounter++) {
                                if (response.body.requestsUpdates[responseAutoUpdateCounter].company_id == companies[companiesCounter].company_id) {
                                    companies[companiesCounter].requestsUpdates = response.body.requestsUpdates[responseAutoUpdateCounter].request_count
                                }
                            }
                            for (let responseAutoUpdateCounter30Days = 0; responseAutoUpdateCounter30Days < response.body.requestsUpdates30Days.length; responseAutoUpdateCounter30Days++) {
                                if (response.body.requestsUpdates30Days[responseAutoUpdateCounter30Days].company_id == companies[companiesCounter].company_id) {
                                    companies[companiesCounter].requestsUpdates30Days = response.body.requestsUpdates30Days[responseAutoUpdateCounter30Days].request_count
                                }
                            }
                            for (let responseCompanyCounter = 0; responseCompanyCounter < response.body.companiesUsers.length; responseCompanyCounter++) {
                                if (response.body.companiesUsers[responseCompanyCounter].company_id == companies[companiesCounter].company_id) {
                                    companies[companiesCounter].userCount = response.body.companiesUsers[responseCompanyCounter].user_count
                                }
                            }
                        }
                        this.companies = companies
                        this.fetchCsCompanies()

                        console.log(companies)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        mounted() {
            this.fetchCompanies()
        }
    }
</script>

<style scoped>
    .truncate-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px; /* Passen Sie die maximale Breite nach Bedarf an */
    }
    .truncate-tooltip {
        max-width: 600px; /* Passen Sie die maximale Breite des Tooltips nach Bedarf an */
        word-break: break-all; /* Fügt einen Zeilenumbruch an jedem Zeichen hinzu, um den Text mehrzeilig darzustellen */
    }
</style>
